import React, { useState, useEffect} from "react";

import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import axios from "axios";
import { urlServerAdmin } from "../utils/UrlServerAdmin";
import { useAuthStore } from "../context/useAuthStore";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import AlertComponent from "../components/CargaComponents/AlertComponent";
import { formatTimestamp } from "../constants/Functions";
import { doc, getDoc } from "firebase/firestore"; 
import { db } from "../services/firebase";
import { useTittleContenidoStore } from "../context/tittleContenidoStore";

const AdminUsers = () => {
  const { Worker, workerToken, fetchWithFreshToken }: any =
    useAuthStore();
  const {setTittleContenido} :any= useTittleContenidoStore();
  const [users, setUsers] = useState<any[]>([]); // Estado para almacenar los usuarios
  const [loading, setLoading] = useState(true); // Estado para mostrar el estado de carga
  const [isLoadingAsync, setIsLoadingAsync] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para modal de edición
  const [selectedUser, setSelectedUser] = useState<any>(null); // Estado para el usuario seleccionado para editar
  const [search, setSearch] = useState(""); // Estado para búsqueda
  const [warnigRegistry, setWarnigRegistry] = useState(false); // Controla la visibilidad de un alert al existir un error en la creación de un nuevo usuario
  const [error, setError] = useState("");
  const [isModalRegistryOpen, setIsModalRegistryOpen] = useState(false); // Controla la visibilidad del modal
  const [newUser, setNewUser] = useState({
    dni: "",
    nombres: "",
    apellidos: "",
    perfil: "",
    email: "",
    password: "",
    disabled: false,
    usuarioCreador: Worker.email,
  }); // Estado para el nuevo usuario


  // Función para obtener la lista de usuarios de Firestore
  const fetchUsers = async () => {
    setLoading(true);
    try {
      // Obtener usuarios de endpoint de backend con el token de autenticación
      const response = await fetchWithFreshToken(
        `${urlServerAdmin}get-admin-workers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (response.ok) {
        const data = await response.json();
        
        setUsers(data.adminUsers);
      } else {
        console.error("Error en la respuesta de la API:", response.statusText);
      }
    } catch (error) {
      console.error("Error al obtener los usuarios:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
     setTittleContenido('Administrar Usuarios')
  }, [setTittleContenido])
  // Usar useEffect para llamar fetchUsers solo al montar el componente
  useEffect(() => {

    if (workerToken) {
      fetchUsers();
    }
  }, [workerToken]); // Dependencia workerToken para que solo se ejecute al tener un token

  // Registro de nuevo usuario
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewUser((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleAddUser = async () => {
    setIsLoadingAsync(true);
    try {
      // Guardar en Firebase mediante api mediante axios
      const response = await axios.post(
        `${urlServerAdmin}create-admin-worker`,
        newUser,
        {
          headers: {
            Authorization: `Bearer ${workerToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response", response);
      // Guardar en Firebase mediante api mediante axios
      setIsModalRegistryOpen(false); // Cerrar el modal
      setNewUser({
        dni: "",
        nombres: "",
        apellidos: "",
        perfil: "",
        email: "",
        password: "",
        disabled: false,
        usuarioCreador: "",
      }); // Limpiar el formulario
      fetchUsers(); // Recargar usuarios después de agregar
    } catch (error: any) {
      console.error("Error adding user:", error.response.data.message);
      setWarnigRegistry(true);
      setError(error.response.data.message);
      alert('Si no se ha creado el usuario, tu tocken puede que haya vencido o no estas completando los campos obligatorios.');
    } finally {
      setIsLoadingAsync(false);
    }
  };

  // Función para eliminar usuario
  const handleDelete = async (userId: string) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar este usuario?")) {
      setIsLoadingAsync(true);
      try {
        const response = await axios.post(
          `${urlServerAdmin}delete-admin-worker`,
          { dni: userId },
          {
            headers: {
              Authorization: `Bearer ${workerToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("response", response);
        fetchUsers(); // Recargar usuarios después de eliminar
      } catch (error) {
        console.error("Error deleting user:", error);
        alert('Si no se ha eliminado el usuario, tu tocken puede que haya vencido. Vuelve a iniciar sesion.');
      } finally {
        setIsLoadingAsync(false);
      }
    }
  };

  // Función para abrir modal de edición con datos de usuario
  const handleEdit = async (user: any) => {
    //Extraer datos del usuario de firestore
    const userSnapshot = await getDoc(doc(db, "workers", user.uid));
    const userData = userSnapshot.data();
    setSelectedUser(userData);
    setIsModalOpen(true);
  };

  // Función para actualizar el perfil del usuario
  const handleUpdate = async () => {
    setIsLoadingAsync(true);
    if (selectedUser) {
      try {
        const response = await axios.post(
          `${urlServerAdmin}update-admin-worker`,
          selectedUser,
          {
            headers: {
              Authorization: `Bearer ${workerToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("response", response);
        setIsLoadingAsync(false);
        if (response.status === 200) {
          setIsLoadingAsync(false);
          alert(response.data.message);
          fetchUsers(); // Recargar usuarios después de actualizar
          setIsModalOpen(false);
        }
      } catch (error) {
        console.error("Error updating user:", error);
        alert('Si no se ha actualizado el usuario, tu tocken puede que haya vencido. Vuelve a iniciar sesion.');
      } finally {
        setIsLoadingAsync(false);
      }
    }
  };

  // Función para cambiar el estado del usuario
  function handleChangeStatusWorker(event: SelectChangeEvent) {
    const { value } = event.target;
    setNewUser((prevState: any) => ({
      ...prevState,
      disabled: value === "true", // Convertir a booleano
    }));
  }

  //funcion para actualizar el estado del usuario
  function handleUpdateStatusWorker(event: SelectChangeEvent) {
    const { value } = event.target;
    console.log(selectedUser);
    setSelectedUser((prevState: any) => ({
      ...prevState,
      disabled: value === "true", // Convertir a booleano
    }));
  }

  // Función para cambiar el perfil del usuario
  function handleChange(event: SelectChangeEvent) {
    const { name, value } = event.target;
    setNewUser((prevState) => ({
      ...prevState,
      [name]: value.toLowerCase(),
    }));
  }

  // Función para actualizar el perfil del usuario
  function handleUpdateProfile(event: SelectChangeEvent) {
    const { name, value } = event.target;
    setSelectedUser((prevState: any) => ({
      ...prevState,
      [name]: value.toLowerCase(),
    }));
  }

  // Funcion para filtrar datos de usuario que se ingresan en la busqueda

  const filteredUsers = users.filter(
    (user) =>
      user.displayName.toLowerCase().includes(search.toLowerCase()) ||
      user.email.toLowerCase().includes(search.toLowerCase())
  );
  // Renderización de la tabla con los usuarios
  return (
    <div>
      <div className="d-flex justify-content-between h-100 ">
        <h2>Administrar Usuarios</h2>
        {/* Boton y modal de registro de nuevo usuario */}
        <div>
          <Button
            variant="contained"
            color="success"
            onClick={() => setIsModalRegistryOpen(true)}
          >
            Agregar Usuario
          </Button>

          <Dialog
            open={isModalRegistryOpen}
            onClose={() => setIsModalRegistryOpen(false)}
          >
            {warnigRegistry && (
              <AlertComponent
                message={error}
                onClose={() => setWarnigRegistry(false)}
                severety="warning"
                enabled={warnigRegistry}
              />
            )}
            <DialogTitle>Agregar Nuevo Usuario</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="DNI"
                name="dni"
                value={newUser.dni}
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
                type="number"
                required
              />
              <TextField
                margin="dense"
                label="Nombres"
                type="text"
                name="nombres"
                value={newUser.nombres}
                onChange={handleInputChange}
                fullWidth
                required
              />
              <TextField
                margin="dense"
                label="Apellidos"
                name="apellidos"
                value={newUser.apellidos}
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
                required
              />
              <TextField
                margin="dense"
                label="Correo electrónico institucional"
                type="email"
                name="email"
                value={newUser.email}
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
                required={true}
              />
              <TextField
                margin="dense"
                label="Contraseña"
                type="password"
                name="password"
                value={newUser.password}
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
                required
              />

              <FormControl margin="dense" fullWidth>
                <InputLabel id="select-label">Seleccionar perfil</InputLabel>
                <Select
                  labelId="select-label"
                  id="select-perfil"
                  value={newUser.perfil}
                  label="Selecciona Perfil"
                  onChange={handleChange}
                  name="perfil"
                >
                  <MenuItem value={"admin"}>Administrador</MenuItem>
                  <MenuItem value={"worker"}>Trabajador</MenuItem>
                </Select>
              </FormControl>
              <FormControl margin="dense" fullWidth>
                <InputLabel id="select-label-status">
                  Estado de cuenta
                </InputLabel>
                <Select
                  labelId="select-label-status"
                  id="disabled"
                  value={newUser.disabled ? "true" : "false"}
                  label="Estado de cuenta"
                  onChange={handleChangeStatusWorker}
                  name="disabled"
                >
                  <MenuItem value="false">Activo</MenuItem>
                  <MenuItem value="true">Inactivo</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            {isLoadingAsync && <BackdropComponent enabled={isLoadingAsync} />}
            <DialogActions>
              <Button
                onClick={() => setIsModalRegistryOpen(false)}
                color="secondary"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleAddUser}
                color="primary"
                variant="contained"
              >
                Guardar
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <TextField
          label="Buscar por nombre o correo"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-25"
        />
      </div>

      {loading ? (
        <BackdropComponent enabled={loading} />
      ) : (
        <div style={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Nombre </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                Correo Electrónico
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Perfil</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                Fecha de Creación
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Estado</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUsers.map((user) => (
              <TableRow key={user.uid}>
                <TableCell>{user.displayName}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.perfil}</TableCell>
                <TableCell>{formatTimestamp(user.createdAt)}</TableCell>
                <TableCell>{user.disabled ? "Inactivo" : "Activo"}</TableCell>
                <TableCell>
                  <Button variant="contained" onClick={() => handleEdit(user)}>
                    Editar
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleDelete(user.uid)}
                  >
                    Eliminar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
      )}

      {/* Modal para editar usuario */}
      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Editar Usuario</DialogTitle>
          <DialogContent>
            <TextField
              label="Nombre"
              value={selectedUser?.nombres || ""}
              fullWidth
              margin="normal"
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, nombres: e.target.value })
              }
            />
            <TextField
              label="Apellidos"
              value={selectedUser?.apellidos || ""}
              fullWidth
              margin="normal"
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, apellidos: e.target.value })
              }
            />
            <TextField
              label="Correo Electrónico"
              value={selectedUser?.email || ""}
              fullWidth
              margin="normal"
              onChange={(e) =>
                setSelectedUser({ ...selectedUser, email: e.target.value })
              }
            />
            <FormControl margin="dense" fullWidth>
              <InputLabel id="select-label">Seleccionar perfil</InputLabel>
              <Select
                labelId="select-label"
                id="select-perfil"
                value={selectedUser?.perfil}
                label="Selecciona Perfil"
                onChange={handleUpdateProfile}
                name="perfil"
              >
                <MenuItem value={"admin"}>Administrador</MenuItem>
                <MenuItem value={"worker"}>Trabajador</MenuItem>
              </Select>
            </FormControl>

            <FormControl margin="dense" fullWidth>
              <InputLabel id="select-label-disabled">
                Seleccionar estado de usuario
              </InputLabel>
              <Select
                labelId="select-label-disabled"
                id="select-status-worker"
                value={selectedUser?.disabled === true ? "true" : "false"}
                label="Seleccionar estado de usuario"
                onChange={handleUpdateStatusWorker}
                name="disabled"
              >
                <MenuItem value={"true"}>Inactivo</MenuItem>
                <MenuItem value={"false"}>Activo</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsModalOpen(false)} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleUpdate} color="primary" variant="contained">
              Actualizar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default AdminUsers;
